import '@repo/ui/globals.css';
import '@/styles/style.scss';
import '@/styles/index.scss';
import { PageNavigationEventProvider, RouterProvider, usePageRouterAdapter } from '@repo/platform';
import { Toaster } from '@repo/ui';
import { Provider as JotaiProvider } from 'jotai';
import Head from 'next/head';
import React from 'react';

import { DefaultActionScripts } from '@/components/layout/DefaultActionScripts';
import OgMetaHead from '@/components/layout/OgMetaHead';
import { RefundAppContents } from '@/components/layout/RefundAppContents';
import { AppPropsWithLayout } from '@/lib/types/layout';

function MyApp({ Component, pageProps, ...rest }: AppPropsWithLayout) {
  const router = usePageRouterAdapter();

  return (
    <>
      <Head>
        <title>비즈넵 환급</title>
        <OgMetaHead pathname={rest.router.pathname} />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover" />
      </Head>

      <JotaiProvider>
        <RouterProvider router={router}>
          <DefaultActionScripts />
          <Toaster />

          <PageNavigationEventProvider>
            <RefundAppContents Component={Component} pageProps={pageProps} {...rest} />
          </PageNavigationEventProvider>
        </RouterProvider>
      </JotaiProvider>
    </>
  );
}

export default MyApp;
